import ProductDetail1 from "routes/adminMobile/images/productDetail_1.png";
import ProductDetail2 from "routes/adminMobile/images/productDetail_2.png";
import ProductDetail3 from "routes/adminMobile/images/productDetail_3.png";

const testEventData = [];

// 날짜 형식을 'YYYY-MM-DD'로 반환하는 함수
function formatDate(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  return `${year}.${month}.${day}`;
}

// 오늘 날짜
const today = new Date();

for (let i = 1; i <= 10; i++) {
  const status = Math.random() < 0.5 ? 'post' : 'end'; // post 또는 end 중 하나 랜덤 선택

  const event = {
    id: i, // 이벤트 번호 (자동 증가)
    title: `이벤트 ${i}`, // 이벤트 제목
    image: [ProductDetail1, ProductDetail2, ProductDetail3][Math.floor(Math.random() * 3)], // 랜덤 이미지 선택
    startDate: formatDate(new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)), // 이벤트 시작일 (오늘로부터 일주일 전)
    endDate: formatDate(today), // 이벤트 종료일 (오늘 날짜)
    displayPage: Math.floor(Math.random() * 5) + 1, // 노출 페이지 랜덤 선택
    displayPosition: ['홈화면', '상단배너', '하단배너'][Math.floor(Math.random() * 3)], // 노출 위치 랜덤 선택
    status: status // 상태 랜덤 선택
  };
  testEventData.push(event);
}

export default testEventData;